
export default {
    data () {
        return {}
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        align: {
            type: String,
            default: 'center'
        },
        theme: {
            type: String,
            default: "",
        }
    }
}
